import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../Context/UserContext";
import "../styleSheets/settings.css";

export default function Settings() {
  const { userDetails, getUserProfile, loading } = useContext(UserContext);

  const [telegramAlerts, setTelegramAlerts] = useState(false);
  const [emailAlerts, setEmailAlerts] = useState(false);
  const [savingField, setSavingField] = useState(null);
  const [savedField, setSavedField] = useState(null);

  useEffect(() => {
    if (userDetails) {
      setTelegramAlerts(userDetails.telegramAlerts || false);
      setEmailAlerts(userDetails.emailAlerts || false);
    }
  }, [userDetails]);

  const handleTelegramToggle = async () => {
    const newValue = !telegramAlerts;
    setTelegramAlerts(newValue);
    try {
      setSavingField("telegram");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/editUser/${userDetails._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            telegramAlerts: !telegramAlerts,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        setTelegramAlerts(!telegramAlerts);
        await getUserProfile();
      }
    } catch (err) {
      setTelegramAlerts(!newValue);
      console.error(err);
    } finally {
      setSavingField(null);
      setSavedField("telegram");

      setTimeout(() => {
        setSavedField(null);
      }, 1500);
    }
  };

  const handleEmailToggle = async () => {
    const newValue = !emailAlerts;
    setEmailAlerts(newValue);
    try {
      setSavingField("email");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/editUser/${userDetails._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            emailAlerts: !emailAlerts,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        setEmailAlerts(!emailAlerts);
        await getUserProfile();
      }
    } catch (err) {
      setEmailAlerts(!newValue);
      console.error(err);
    } finally {
      setSavingField(null);
      setSavedField("email");

      setTimeout(() => {
        setSavedField(null);
      }, 1500);
    }
  };

  if (loading) {
    return (
      <div className="page-loader">
        <div className="page-spinner"></div>
      </div>
    );
  }

  return (
    <div className="alerts-wrapper">
      <div className="alerts-card">
        {/* Telegram */}
        <div className="alert-row">
          <div className="alert-text">
            <label className="alert-label">Telegram Alerts</label>
            <p className="alert-sub">
              Get real-time transaction updates on Telegram
            </p>
          </div>

          <div className="switch-container">
            {savingField === "telegram" ? (
              <div className="mini-spinner"></div>
            ) : savedField === "telegram" ? (
              <div className="saved-check">✓</div>
            ) : (
              <div className="form-check form-switch">
                <input
                  className="form-check-input custom-switch"
                  type="checkbox"
                  checked={telegramAlerts}
                  onChange={handleTelegramToggle}
                />
              </div>
            )}
          </div>
        </div>

        {telegramAlerts && (
          <div className="alert-note">
            Telegram alerts will only work if you've updated your Telegram
            username in your SplitBites profile.
            <br />
            And then{" "}
            <a
              href="https://t.me/splitbites_alert_bot"
              target="_blank"
              rel="noreferrer"
            >
              Click this link
            </a>
            . Activate in telegram by sending "/start" .
          </div>
        )}

        <hr className="alert-divider" />

        {/* Email */}
        <div className="alert-row">
          <div className="alert-text">
            <label className="alert-label">Email Alerts</label>
            <p className="alert-sub">
              Receive email notifications for transactions
            </p>
          </div>

          <div className="switch-container">
            {savingField === "email" ? (
              <div className="mini-spinner"></div>
            ) : savedField === "email" ? (
              <div className="saved-check">✓</div>
            ) : (
              <div className="form-check form-switch">
                <input
                  className="form-check-input custom-switch"
                  type="checkbox"
                  checked={emailAlerts}
                  onChange={handleEmailToggle}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
